
<template>
    <div>
        <br>
        <vx-card class="overlay-card overflow-hidden" title=""  style="height:50%; background:transparent; margin-top:100px;" >
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2" style=" display: flex; align-items: center; justify-content: center;">
                    <h2 class="mb-3 text-center">
                        <b class="title-footer">Visítanos</b>
                        <br>
                        <p class="subTitle-footer">Estamos ubicados en</p>
                        <p class="text-footer"> Urb. Entrerios Solar 12 Mz. Y-1 Local 2  </p>
                        <p class="text-footer">(Edificio Rotary, a lado de clap)</p>
                        <br>
                        <b class="subTitle-footer">Horarios de atención</b>
                        <p class="text-footer"> Lunes a Viernes</p> 
                        <p class="text-footer"> 7:15 - 15:30 </p>
                        <br>
                        <b class="subTitle-footer">Número de contacto</b>
                        <p class="text-footer">+593 4 283 7629</a> </p>
                    </h2>
                    <!--h2 class="mb-3 text-center"><b>Estamos ubicados en</b> <br> Urb. Entrerios Solar 12 Mz. Y-1 Local 2 <br>(Edificio Rotary, a lado de clap)
                        <br> <b>Horarios de atención</b> <br> Lunes a Viernes <br> 7:15 - 15:30 
                    </h2-->
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3987.023094402034!2d-79.86757352607482!3d-2.144839937165009!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x902d6d9dcebaa2db%3A0x7d5733cee4ba0cbd!2sTienda%20Mapgrafi!5e0!3m2!1ses!2sec!4v1706904055952!5m2!1ses!2sec" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
             </div>
         </vx-card>
        <footer class="the-footer flex-wrap justify-between" :class="classes" style="width:100% ; background:#0d873b; color:#fff;">
                <!-- vs-button color="warning" type="filled" icon-pack="feather" icon="icon-archive"  ></vs-button-->

                <!--div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/4 xl:w-2/4 mb-base">
                    <vx-card
                        title="Title Color"
                        title-color="success"
                        subtitle="Brownie pastry chocolate pastry chocolate pudding.">
                        <p class="mb-3">You can use <code>title-color</code> prop to change color of title of card. This prop supports hex, rgba, rgb and theme colors.</p>
                        <p class="mb-3">Oat cake powder sesame snaps. Chocolate bar dessert bonbon chocolate bar pudding apple pie muffin chocolate ice cream. I love bear claw I love.</p>
                    </vx-card>
            </div>
            <div class="vx-col  sm:w-1/2 md:w-1/2 lg:w-4/4 xl:w-4/4 mb-base">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1409.6247718592856!2d-79.86085129794195!3d-2.145666266046561!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x902d6cf7329fb22f%3A0x85df6008ac2e214a!2sIPAC!5e0!3m2!1ses-419!2sec!4v1577368498989!5m2!1ses-419!2sec" width="100%" height="300" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
            </div -->
                    <span>@ <a style="color:white!important;" href="https://www.mapgrafi.com"  target="_blank" rel="nofollow">Mapgrafi S.A. {{ new Date().getFullYear() }}</a>. Todos los derechos reservados.</span>
                <span class="md:flex hidden items-center">
                    <!--span>Desarrollado por <a href="https://www.viamatica.com" target="_blank" rel="nofollow">Viamatica S.A.</a></span-->
                </span>
        </footer>
    </div>
</template>

<script>
export default {
    name: "the-footer",
      props: {
        classes: {
            type: String,
        },
    },
}
</script>
<style>
.title-footer{
    font-size: 40px;
}
.subTitle-footer{
    margin-top: 40px;
    font-weight: 400;
}
.text-footer{
    width: auto !important;
    font-weight: 100;
    color: black;
}

</style>
